import { Chart, ChartData, ChartOptions } from 'chart.js'
import { useRef } from 'react'
import { Bar, getElementAtEvent } from 'react-chartjs-2'
import Helper from '../../helpers/Helper'
import ChartsHelper from './ChartsHelper'

interface Props {
    data: ChartData<'bar', number[] | number[][], unknown>
    options?: ChartOptions<'bar'>
    isLoading?: boolean
    onClickSerie?: (options: { seriesName: string, index: number }) => void
}

const HorizontalBarChart = ({ data, options, isLoading, onClickSerie }: Props) => {
    let chartData = data
    let chartOptions = options
    const chartRef = useRef<Chart<'bar', number[], unknown>>(null)

    const handleChartHover = (event: any, activeElements: Array<any>) => {
        const canvas = chartRef.current?.canvas

        if (activeElements.length > 0 && Helper.hasVal(onClickSerie)) {
            canvas.style.cursor = 'pointer'
        } else {
            canvas.style.cursor = 'default'
        }
    }

    const handleChartClick = (event: React.MouseEvent<HTMLCanvasElement>) => {
        const myChart = chartRef.current
        const elements = getElementAtEvent(myChart, event)

        if (Helper.hasVal(elements) && elements.length > 0) {
            const datasetIndex = elements[0].datasetIndex
            const dataIndex = elements[0].index

            if (onClickSerie)
                onClickSerie({ index: dataIndex, seriesName: data.labels[datasetIndex] as string })
        }
    }

    if (isLoading) {
        chartData = {
            datasets: [
                { data: Array(5).fill(0).map(() => Math.random() * 11) }
            ],
            labels: Array(5).fill(0).map(() => '')
        }

        chartOptions = {
            ...chartOptions,
            maintainAspectRatio: false,
            indexAxis: 'y',
            plugins: {
                datalabels: { display: false },
                legend: { display: false },
                tooltip: { enabled: false }
            },
            scales: { x: { display: false } }
        }
    }

    const myOptions: ChartOptions<'bar'> = {
        ...{
            maintainAspectRatio: false,
            indexAxis: 'y',
            plugins: { datalabels: { display: false }, legend: { display: false } },
            scales: {
                x: { grid: { display: false } },
                y: { grid: { color: 'rgba(166,166,166, 0.35)' } }
            },
            datasets: {
                bar: {
                    borderRadius: 4,
                    borderSkipped: false
                }
            }
        }, ...chartOptions
    }

    ChartsHelper.applyColors(chartData.datasets as any, isLoading)
    ChartsHelper.applyMode(myOptions)

    return (
        <div style={{ flex: 1 }}>
            <Bar
                ref={chartRef}
                data={chartData}
                width='100%'
                height='100%'
                options={{
                    ...myOptions,
                    onHover: (event, activeElements) => handleChartHover(event.native, activeElements)
                }}
                onClick={handleChartClick}
            />
        </div>
    )
}

export default HorizontalBarChart
